import { Form } from "@remix-run/react";
import { Trans, useTranslation } from "react-i18next";
import IconLock from "~/assets/icons/lock.svg";
import { Button } from "~/components/Button";
import { CountDownResendCode } from "~/components/CountDownResendCode";
import { Input } from "~/components/Input";
import { BodyMedium } from "~/components/Typography";

export const OtpForm: React.FC<{
  isLoading: boolean;
  backendSessionId: string;
  otpType: string;
  userId: string;
  email: string;
  is2FA: boolean;
  error?: string;
}> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <header className="leading-13 mb-3 text-[40px] font-bold leading-none text-[#072236]">
        {props.is2FA
          ? t("webapp.login.mfa.title_2fa", "Verify 2FA")
          : t("webapp.login.mfa.title", "Verify OTP")}
      </header>
      <BodyMedium className="mb-5 font-semibold text-gray-600">
        {props.is2FA
          ? t(
              "webapp.login.mfa.description_2fa",
              "Enter 6-digit verification code from your Authenticator app"
            )
          : t(
              "webapp.login.mfa.description",
              "Please enter the code that we sent to: {{email}}",
              { email: props.email }
            )}
      </BodyMedium>
      <Form className="flex flex-col gap-6" method="post">
        <input type="hidden" name="step" defaultValue="otp" />
        <input type="hidden" name="email" defaultValue={props.email} />
        <input
          type="hidden"
          name="backendSessionId"
          defaultValue={props.backendSessionId}
        />
        <input type="hidden" name="otpType" defaultValue={props.otpType} />
        <input type="hidden" name="userId" defaultValue={props.userId} />
        <Input
          name="otpCode"
          autoComplete="off"
          type="text"
          inputMode="numeric"
          autoFocus
          required
          disabled={props.isLoading}
          maxLength={6}
          minLength={6}
          className="!w-full !text-left"
        />
        {props.error && (
          <p className="typesetting-validation-error w-full text-center">
            {props.error}
          </p>
        )}
        <Button
          loading={props.isLoading}
          data-test-id="login-continue-button"
          className="flex items-center justify-center"
        >
          <img alt="" src={IconLock} className="mr-3 h-4 w-4" />
          <Trans i18nKey={"webapp.continue"}>Continue</Trans>
        </Button>
        {props.is2FA ? (
          <Trans i18nKey={"webapp.login.lost_auth_app"}>
            <p className="w-full text-center text-[14px] font-semibold leading-[22px]">
              Lost access to your Authenticator app?
              <a
                className="text-link block"
                href="https://help.finblox.com/en/articles/6201203-how-do-i-restore-access-to-my-account-with-the-2fa-backup-key"
                target="_blank"
                rel="noreferrer"
              >
                Learn More
              </a>
            </p>
          </Trans>
        ) : (
          !props.isLoading && <CountDownResendCode backUrl="/login" />
        )}
      </Form>
    </div>
  );
};
